<script setup >
import { inject } from 'vue'
import stripslashes from '@/Shared/helper.js'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import ButtonSetInBrand from '@/Shared/ButtonSet/ButtonSetInBrand'
const data = inject('data')
</script>

<template>
  <div class="relative py-[88px] sm:py-28 md:py-32 !border-b-2 !border-[#eee]">
    <Breadcrumbs class="!flex !max-w-none absolute top-8 left-6 sm:left-8 w-[calc(100%_-_48px)] sm:w-[calc(100%_-_64px)]" category="brand" :title="data.brandNameLocal" />
    <div class="contentsContainer md:!max-w-[740px] lg:!max-w-[740px] xl:!max-w-[740px] 2xl:!max-w-[740px]">
      <h1 class="text-[38px] xs:text-[42px] sm:text-[46px] md:text-[50px] font-rift font-bold mb-4 sm:mb-5 md:mb-6">
        {{ stripslashes(data.brandName) }}
        <small class="font-jpsans block mt-3 sm:mt-4 text-[15px] sm:text-[16px]">{{ data.brandNameLocal }}</small>
      </h1>
      <p class="sm:text-[14px] leading-8 mb-10">{{ data.brandIntroTxt }}</p>
      <ButtonSetInBrand :brand-v2="true" class="sm:grid sm:grid-cols-2 md:grid-cols-3 sm:gap-4" />
    </div>
  </div>
</template>


